// extracted by mini-css-extract-plugin
export var container = "career-card-module--container--iygBn";
export var description = "career-card-module--description--gXHBt";
export var location = "career-card-module--location--s8Bje";
export var locationImg = "career-card-module--location-img--ENzkg";
export var logoImage = "career-card-module--logo-image--cd2d1";
export var title = "career-card-module--title--mf1jk";